import axios from 'axios';
import { UPDATE_BY_KDMAX_CART_TYPE } from './api.config';

export default async function (areDTSProductsDeleted) {
    const { data } = await axios({
        method: 'post',
        url: UPDATE_BY_KDMAX_CART_TYPE,
        params: {
            kdmax_cart_type: areDTSProductsDeleted ? 1 : 2,
        },
    });
    return data;
}
